import { tr } from 'pmt-modules/i18n'
import React from 'react'
import classNames from 'classnames'
import isEmpty from 'lodash/isEmpty'

import { withStyles } from 'pmt-ui/styles'
import { TypographyCustom } from 'pmt-ui/Typography'
import Button from 'pmt-ui/Button'
import ShoppingBasket from 'pmt-ui/svg-icons/action/shopping-basket'
import WheatIcon from 'pmt-ui/svg-icons/food/wheat'
import Price from 'pmt-ui/Price'

import CartModifierTag from 'app/components/CartModifierTag'
import Chip from 'app/components/Chip'

import PartsView from './PartsView'

const styles = theme => ({
  header: {
    width: '100%',
    paddingBottom: theme.spacing(6),
  },
  productName: {
    flex: ' 0 0 100%',
  },
  productDescription: {
    marginTop: theme.spacing(3),
    flex: ' 0 0 100%',
  },
  allergen: {
    display: 'flex',
    marginTop: theme.spacing(3),
    justifyContent: 'flex-start',
    marginLeft: `-${theme.spacing(1)}px`,
    color: theme.palette.primary.main,
    alignItems: 'center',
    textDecoration: 'underline',
    '& svg': {
      marginRight: `0 !important`,
    },
  },
  buttonAdd: {
    width: 104,
    padding: `${theme.spacing(3)}px ${theme.spacing(4)}px`,
    margin: `${theme.spacing(4)}px 0 0`,
    background: theme.palette.primary.main,
    color: theme.pmt.colors.white,
    transition: 'width .2s ease-in',
  },
  buttonAddValid: {
    width: 813,
    textAlign: 'center',
  },
  buttonIcon: {
    float: 'left',
    width: 40,
    height: 40,
  },
  buttonAddText: {
    color: theme.pmt.colors.white,
    textTransform: 'initial',
  },
  buttonText: {
    marginLeft: theme.spacing(3),
    minHeight: 34,
    maxHeight: 34,
    overflow: 'hidden',
    display: '-webkit-box',
    textOverflow: 'ellipsis',
    '-webkit-line-clamp': 1,
    '-webkit-box-orient': 'vertical',
    lineHeight: '34px',
  },
  priceContainer: {
    marginTop: theme.spacing(2),
  },
  price: {
    alignItems: 'baseline',
  },
  basePrice: {
    '& > hr': {
      top: 13,
    },
  },
  cartModifierContainer: {
    marginTop: theme.spacing(2),
    display: 'flex',
  },
  cartModifierChip: {
    marginRight: theme.spacing(1),
    cursor: 'pointer',
    borderRadius: 4,
  },
})

const MenuView = ({
  orderMenu,
  viewOptions,
  category,
  restaurant,
  onReturnToPreviousPartCategory,
  onSelectCategory,
  onSelectOrderProduct,
  onUnselectOrderProduct,
  onAddToCartFromShortcut,
  onSubmitOrderMenu,
  resetPartCategory,
  showDietaryInfoDialog,
  classes,
}) => (
  <React.Fragment>
    <div className={classes.header}>
      <div>
        <TypographyCustom type="487" className={classes.productName}>
          {orderMenu.name}
        </TypographyCustom>
        <TypographyCustom type="244" className={classes.productDescription}>
          {orderMenu.description}
        </TypographyCustom>

        <TypographyCustom type="487" className={classes.priceContainer}>
          <Price
            value={orderMenu.priceFormatted}
            hasCartModifier={orderMenu.hasCartModifier}
            baseValue={orderMenu.hasCartModifier ? orderMenu.basePriceFormatted : null}
            classes={{ root: classes.price, baseValue: classes.basePrice }}
          />
        </TypographyCustom>

        {orderMenu.hasCartModifier && (
          <div className={classes.cartModifierContainer}>
            {orderMenu.cartModifiers.list.map((cartModifier, index) => (
              <CartModifierTag
                cartModifier={cartModifier}
                chipElement={
                  <Chip
                    key={index}
                    label={cartModifier.tag}
                    classes={{ root: classes.cartModifierChip }}
                  />
                }
                key={index}
              />
            ))}
          </div>
        )}

        {orderMenu.hasAllergens && (
          <TypographyCustom
            type="244"
            skipColor
            className={classes.allergen}
            onClick={showDietaryInfoDialog}
          >
            <WheatIcon className={classes.buttonIcon} />
            {tr('kiosk.order.dialog.dietary_info.title')}
          </TypographyCustom>
        )}
      </div>
      <TypographyCustom type="327" skipColor>
        {({ className }) => (
          <Button
            variant="contained"
            color="primary"
            disabled={!orderMenu.isValid}
            classes={{
              root: classNames(classes.buttonAdd, {
                [classes.buttonAddValid]: orderMenu.isValid,
              }),
              label: classNames(className, classes.buttonAddText),
            }}
            onClick={() => {
              onSubmitOrderMenu(orderMenu)
            }}
          >
            <ShoppingBasket className={classes.buttonIcon} />
            {orderMenu.isValid && (
              <span className={classes.buttonText}>
                {!viewOptions.isEditMode
                  ? `${tr('global.order.add_to_cart')} ( ${orderMenu.totalPriceFormatted} )`
                  : tr('global.order.update')}
              </span>
            )}
          </Button>
        )}
      </TypographyCustom>
    </div>
    {!isEmpty(orderMenu.parts) && (
      <PartsView
        parts={orderMenu.parts}
        category={category}
        restaurant={restaurant}
        viewOptions={viewOptions}
        onReturnToPreviousPartCategory={onReturnToPreviousPartCategory}
        onSelectCategory={onSelectCategory}
        onSelectOrderProduct={onSelectOrderProduct}
        onUnselectOrderProduct={onUnselectOrderProduct}
        onAddToCartFromShortcut={onAddToCartFromShortcut}
        resetPartCategory={resetPartCategory}
      />
    )}
  </React.Fragment>
)

export default withStyles(styles)(MenuView)
